module.exports = __webpack_public_path__ + "img/radio-normal.fed12f43.svg";